import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cff31a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title container-title" }, "团队管理", -1))
const _hoisted_3 = { class: "block-head row" }
const _hoisted_4 = { class: "block-search" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-plus" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 新增成员 ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { class: "row name-item" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("管理员")
const _hoisted_13 = { class: "row" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "form" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "姓名：", -1))
const _hoisted_19 = { class: "form-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "手机号：", -1))
const _hoisted_21 = { class: "form-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            placeholder: "姓名",
            modelValue: _ctx.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            class: "mini-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, " 查询 ")
        ]),
        _createElementVNode("button", {
          class: "mini-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isAdd = true))
        }, _hoisted_7)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%"},
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "real_name",
              label: "成员名称"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    class: "avatar",
                    src: scope.row.avatar
                  }, null, 8, _hoisted_11),
                  _createElementVNode("span", null, _toDisplayString(scope.row.real_name), 1),
                  (scope.row.is_super)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "mobile",
              label: "手机号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "last_login_time",
              label: "上次登录"
            }),
            _createVNode(_component_el_table_column, {
              prop: "",
              width: "100",
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", {
                    class: "link",
                    onClick: ($event: any) => (_ctx.edit(scope.row))
                  }, "编辑", 8, _hoisted_14),
                  _createElementVNode("span", {
                    class: "link red",
                    onClick: ($event: any) => (_ctx.deletePeople(scope.row))
                  }, "删除", 8, _hoisted_15)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    (_ctx.isAdd || _ctx.isEdit)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 0,
          width: "500px",
          dataTitle: _ctx.isEdit ? '修改信息' : '新增团队成员',
          onClose: _ctx.cancelAddEdit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_input, {
                  type: "text",
                  placeholder: "请输入成员姓名",
                  modelValue: _ctx.addPeopleData.realName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addPeopleData.realName) = $event)),
                  class: "value"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _ctx.addPeopleData.mobile,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addPeopleData.mobile) = $event)),
                  placeholder: "请输入成员手机号",
                  class: "value"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_ctx.isAdd)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addPeople && _ctx.addPeople(...args)))
                    }, " 增加 "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addPeople && _ctx.addPeople(...args)))
                    }, "编辑"))
              ])
            ])
          ]),
          _: 1
        }, 8, ["dataTitle", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}